import React from 'react';
import {
    StyledButton,
    StyledButtonSave,
    StyledButtonShare,
    StyledButtonEmail,
    StyledButtonCall,
    StyledButtonText
} from './Buttons.styles';
import { ButtonShareProps, ButtonSaveProps } from './Buttons.types';
import {
    ShareiosSmall,
    ShareSmall,
    SaveFillSmall,
    SaveOutlineSmall,
    PhoneFillSmall,
    EmailFillSmall
} from '@blueprint/icons';

type PropsButton = React.ComponentProps<typeof StyledButton>;
type PropsButtonText = React.ComponentProps<typeof StyledButtonText>;

export const ButtonEmail = (props: PropsButton) => {
    return (
        <StyledButtonEmail {...props} isFullWidth>
            <EmailFillSmall />
            {props.children}
        </StyledButtonEmail>
    );
};

export const ButtonCall = (props: PropsButton) => {
    return (
        <StyledButtonCall {...props} isFullWidth>
            <PhoneFillSmall />
            {props.children}
        </StyledButtonCall>
    );
};

export const ButtonShare = React.forwardRef<
    HTMLButtonElement,
    ButtonShareProps
>((props, ref) => {
    const icon = props.isAndroid ? <ShareSmall /> : <ShareiosSmall />;
    const label = 'Share';

    return (
        <StyledButtonShare
            {...props}
            ref={ref}
            aria-label={label}
            variant="secondary"
        >
            {icon} <span>{label}</span>
        </StyledButtonShare>
    );
});

export const ButtonSave = React.forwardRef<HTMLButtonElement, ButtonSaveProps>(
    (props, ref) => {
        const { isSaved } = props;
        const icon = isSaved ? (
            <SaveFillSmall aria-hidden="true" />
        ) : (
            <SaveOutlineSmall aria-hidden="true" />
        );
        const copy = isSaved ? 'Saved' : 'Save';
        const label = isSaved ? 'Remove saved listing' : 'Save listing';

        return (
            <StyledButtonSave
                {...props}
                ref={ref}
                aria-label={label}
                variant="secondary"
            >
                {icon} <span>{copy}</span>
            </StyledButtonSave>
        );
    }
);

export const ButtonText = React.forwardRef<HTMLButtonElement, PropsButtonText>(
    (props, ref) => {
        return <StyledButtonText variant="tertiary" ref={ref} {...props} />;
    }
);
